import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=46fe378d&scoped=true&"
import script from "./Bottom.vue?vue&type=script&lang=js&"
export * from "./Bottom.vue?vue&type=script&lang=js&"
import style0 from "./Bottom.vue?vue&type=style&index=0&id=46fe378d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe378d",
  null
  
)

export default component.exports